import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';

@Component({
  selector: 'app-paginacion',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="d-flex justify-content-between align-items-center">
      <select class="form-select form-select-sm w-auto"
              [value]="tamanoPagina()"
              (change)="tamanoPaginaCambio.emit(+$any($event.target).value)">
        @for (t of [20, 50, 75, 100]; track t) { <option [value]="t">{{ t }}</option> }
      </select>
      @if (hayMas() || pagina() > 1) {
        <div class="d-flex align-items-center gap-2">
          <span>Página {{ pagina() }}</span>
          <button class="btn btn-sm btn-outline-secondary" [disabled]="pagina() <= 1 || cargando()"
                  (click)="paginaCambio.emit(pagina() - 1)">Anterior</button>
          <button class="btn btn-sm btn-outline-secondary" [disabled]="!hayMas() || cargando()"
                  (click)="paginaCambio.emit(pagina() + 1)">Siguiente</button>
        </div>
      }
    </div>
  `
})
export class PaginacionComponent {
  readonly pagina = input.required<number>();
  readonly tamanoPagina = input.required<number>();
  readonly hayMas = input.required<boolean>();
  readonly cargando = input<boolean>(false);

  readonly paginaCambio = output<number>();
  readonly tamanoPaginaCambio = output<number>();
}
